import { loadStripe } from '@stripe/stripe-js';
import nodeAxiosFirebase from '../utils/nodeAxiosFirebase';

// Initialiser Stripe avec votre clé publique
const stripePromise = loadStripe(
  'pk_live_51PpVVc039uUr8lBdyHrPXPgJbBDldnuBHEMqvbu3I0q05aWx5lQQrVpUEuo3qGEtWcSjx3TFkjdDHr0RYOKbn0fZ0029TBJ0u4'
);

export const stripePromiseInstance = stripePromise;

export const createPaymentIntent = async (
  amount,
  customerId,
  currency = 'cad'
) => {
  try {
    const response = await nodeAxiosFirebase({
      method: 'POST',
      url: 'https://northamerica-northeast1-blue-link-node.cloudfunctions.net/paymentsHandler/create-payment-intent',
      body: {
        amount,
        customerId,
        currency,
      },
    });
    return response;
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

export const processPayment = async (clientSecret) => {
  try {
    const stripe = await stripePromise;
    if (!stripe) {
      throw new Error('Stripe is not initialized');
    }

    const { error } = await stripe.confirmPayment({
      elements: stripe.elements(),
      confirmParams: {
        return_url: window.location.origin + '/payment-success',
      },
    });

    if (error) {
      throw error;
    }
  } catch (error) {
    console.error('Error processing payment:', error);
    throw error;
  }
};

export const createCustomer = async (email, name) => {
  try {
    const response = await nodeAxiosFirebase({
      method: 'POST',
      url: 'https://northamerica-northeast1-blue-link-node.cloudfunctions.net/paymentsHandler/create-customer',
      body: {
        email,
        name,
      },
    });
    return response;
  } catch (error) {
    console.error('Error creating customer:', error);
    throw error;
  }
};

export const attachPaymentMethod = async (customerId, paymentMethodId) => {
  try {
    const response = await nodeAxiosFirebase({
      method: 'POST',
      url: 'https://northamerica-northeast1-blue-link-node.cloudfunctions.net/paymentsHandler/attach-payment-method',
      body: {
        customerId,
        paymentMethodId,
      },
    });
    return response;
  } catch (error) {
    console.error('Error attaching payment method:', error);
    throw error;
  }
};
